module.exports = __webpack_public_path__ + "static/logo-big-main-copy@3x-725fedcf0929ab83427f7ffdf18e04a0.png";